import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  InlineEdit,
  TEXT_LENGTH,
  CurrencyText,
  CurrencyField
} from '@nile/components';
import { TextField } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';

const Wrapper = styled.div`
  .inline-edit--editview__wrapper {
    max-width: ${(props) => (props.multiline ? '100%' : '100px')};
  }
  .subject {
    font-size: 14px !important;
    font-weight: 600;
    height: fit-content;
    white-space: pre-wrap;
    line-break: anywhere;

    .edit-icon {
      visibility: hidden;
      margin-left: 5px;
    }
  }
  .subdued {
    font-weight: 400;
    opacity: 0.8;
  }
  .subject-name {
    height: 100%;
    line-height: 25px;
    overflow: auto;
    padding-right: 5px;
  }
  .subject:hover {
    .edit-icon {
      visibility: visible;
    }
  }
`;

const InlineText = (props) => {
  const { suffix, type, editable = true } = props;
  const [value, setValue] = useState(props.defaultValue);

  useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  const getValue = (val) => {
    switch (type) {
      case 'currency':
        return <CurrencyText value={val} />;
      default:
        return val || 'NA';
    }
  };

  const Component = type === 'currency' ? CurrencyField : TextField;

  return (
    <Wrapper
      className={`inline-text-wrapper ${props.wrapperClassname}`}
      variant={props.variant}
      multiline={props.multiline}
    >
      <InlineEdit
        defaultValue={value}
        editView={({ updateFieldState }, ref) => (
          <div className="mr8">
            <Component
              value={value}
              onChange={(text) => {
                setValue(text);
                updateFieldState(text);
              }}
              onFocus={(event) => event.target.select()}
              autoFocus={props.editMode}
              ref={ref}
              maxLength={props.maxLength || TEXT_LENGTH.size_5}
              noborder
              bgTransparent
              multiline={props.multiline}
              type={props.input || 'text'}
              step={props.step || null}
            />
          </div>
        )}
        saveOnEnter={props.saveOnEnter}
        editMode={props.editMode}
        onCancel={props.onCancel}
        readView={() => (
          <div className="subject flex actr">
            <div
              className={`f11 flex center subject-name ml4 ${
                props.variant ? props.variant : ''
              }`}
            >
              {getValue(value)}
              {suffix ? <div className="ml4">{suffix}</div> : ''}
            </div>
            {editable && (
              <div
                className={`edit-icon ${
                  props.actionClass ? props.actionClass : ''
                }`}
              >
                <SVGIcon name="Edit" />
              </div>
            )}
          </div>
        )}
        onConfirm={(text, cb) => {
          if (!value?.trim()) setValue(props.defaultValue);
          else setValue(value.trim());
          if (props.saveValue) props.saveValue(value, cb);
        }}
        onEditStateChange={(state) => {
          if (props.setEditState) props.setEditState(state);
        }}
        showProgress
        editable={editable}
        hideActionButtons
      />
    </Wrapper>
  );
};

InlineText.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  saveValue: PropTypes.func,
  setEditState: PropTypes.func
};

export default InlineText;
